import { getEnsureLoadedLoader } from './loaderHelper';

export const useGpiReadingsLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('GpiReadings'), 'gpireadings.loading', '');
};
